<section *ngIf="processing">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
  <br />
</section>
<mat-dialog-content *ngIf="!processing">
  <form #form="ngForm" (ngSubmit)="onSubmit()" class="form-field-full">
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <h2 class="noMarginHeader">
          <mat-icon>add</mat-icon> Add Sample
        </h2>
      </div>
      <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
        <button name="SubmitButton" type="submit" value="Create" mat-raised-button color="primary" title="Add" [disabled]="processing">Add</button>
        &nbsp;&nbsp;
        <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel" title="Cancel">Cancel</button>
      </div>
    </div>
    <br />
    <mat-error [hidden]="!postError">
      <ul>
        <li *ngFor="let message of postErrorMessages">{{message}}</li>
      </ul>
    </mat-error>
    <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
      <mat-tab label="Sample Information">
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard" [formGroup]="requestForm">
                    <mat-label>Sample Date</mat-label>
                    <input id="createDate" name="createDate" formControlName="createDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="createDate" />
                    <mat-datepicker-toggle matSuffix [for]="createDate"></mat-datepicker-toggle>
                    <mat-datepicker #createDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Analysis Date</mat-label>
                    <input id="collectionDate" name="collectionDate" [(ngModel)]="sampleViewModel.collectionDate" placeholder="mm/dd/yyyy" required matInput [matDatepicker]="collectionDate" />
                    <mat-datepicker-toggle matSuffix [for]="collectionDate"></mat-datepicker-toggle>
                    <mat-datepicker #collectionDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Created Date</mat-label>
                    <input id="stampedDate" name="stampedDate" [(ngModel)]="sampleViewModel.stampedDate" placeholder="mm/dd/yyyy" required matInput [matDatepicker]="stampedDate" />
                    <mat-datepicker-toggle matSuffix [for]="stampedDate"></mat-datepicker-toggle>
                    <mat-datepicker #stampedDate>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>QA</mat-label>
                    <mat-select id="qa" name="qa" [(ngModel)]="sampleViewModel.qa" matInput>
                      <mat-option *ngFor="let item of oregonWellDataService.qa" value="{{item.value}}">
                        {{item.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Type</mat-label>
                    <mat-select id="retOrNot" name="retOrNot" [(ngModel)]="sampleViewModel.retOrNot" matInput>
                      <mat-option *ngFor="let item of oregonWellDataService.ret" value="{{item.value}}">{{item.text}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="33.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Voucher</mat-label>
                    <mat-select id="voucherId" name="voucherId" [(ngModel)]="sampleViewModel.voucherId" matInput>
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let item of vouchers" value="{{item.voucherId}}">{{item.voucherId}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50.33" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Origin</mat-label>
                    <mat-select id="origin" name="origin" [(ngModel)]="sampleViewModel.origin" matInput>
                      <mat-option *ngFor="let item of oregonWellDataService.originOptions" value="{{item}}">
                        {{item}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-checkbox id="isSampleReTest" name="isSampleReTest" [(ngModel)]="sampleViewModel.isSampleReTest" matInput></mat-checkbox>
                  &nbsp;<small>Linked Sample</small>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Linked Sample Comments</mat-label>
                    <textarea rows="4" cols="100" [(ngModel)]="sampleViewModel.sampleReTestComment" id="sampleReTestComment" name="sampleReTestComment" matInput></textarea>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
          <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-checkbox id="postTreatment" name="postTreatment" [(ngModel)]="sampleViewModel.postTreatment" matInput></mat-checkbox>
                  &nbsp;<small>Post Treatment</small>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                <div fxFlex="100" fxFlex.lt-sm="100">
                  <mat-form-field appearance="standard">
                    <mat-label>Sample Comments</mat-label>
                    <textarea rows="4" cols="100" [(ngModel)]="sampleViewModel.qaFixComment" id="qaFixComment" name="qaFixComment" matInput></textarea>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Test Results">
        <mat-card>
          <div fxLayout="column">
            <mat-error *ngIf="contaminantMsg != ''">
              {{contaminantMsg}}
              <br /><br />
            </mat-error>
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8px" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="start"
              *ngFor="let result of sampleViewModel.parameterResults; let i = index;">
              <div fxFlex="12" fxFlex.lt-sm="100">
                <div>
                  <mat-checkbox id="parameterIsReTest{{i}}" name="parameterIsReTest{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterIsReTest" matInput></mat-checkbox>
                  &nbsp;<small>Retest</small>
                </div>
                <div>
                  <mat-checkbox id="parameterExceedence{{i}}" name="parameterExceedence{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterExceedence" matInput></mat-checkbox>
                  &nbsp;<small>Exceedence</small>
                </div>
              </div>
              <mat-form-field appearance="standard" fxFlex="17" fxFlex.lt-sm="100">
                <mat-label>Analyte</mat-label>
                <select id="parameterCompleteId{{i}}" name="parameterCompleteId{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterCompleteId" #completeField="ngModel"
                  [class.field-error]="completeField.invalid" (change)="contaminantChange();" matNativeControl>
                  <option *ngFor="let item of oregonWellDataService.contaminants" value="{{item.value}}">
                    {{item.text}}
                  </option>
                </select>
              </mat-form-field>
              <mat-form-field appearance="standard" fxFlex="15" fxFlex.lt-sm="100">
                <mat-label>Result</mat-label>
                <input id="parameterResult{{i}}" name="parameterResult{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterResult" required #resultField="ngModel"
                  [class.field-error]="resultField.invalid" matInput />
              </mat-form-field>
              <mat-form-field appearance="standard" fxFlex="15" fxFlex.lt-sm="100">
                <mat-label>Unit</mat-label>
                <select id="parameterUnitId{{i}}" name="parameterUnitId{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterUnitId" required #unitField="ngModel"
                  [class.field-error]="unitField.invalid" matNativeControl>
                  <option *ngFor="let item of oregonWellDataService.units" value="{{item.value}}">
                    {{item.text}}
                  </option>
                </select>
              </mat-form-field>
              <mat-form-field appearance="standard" fxFlex="15" fxFlex.lt-sm="100">
                <mat-label>Method</mat-label>
                <select id="parameterMethodId{{i}}" name="parameterMethodId{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterMethodId" matNativeControl>
                  <option *ngFor="let item of oregonWellDataService.methods" value="{{item.value}}">
                    {{item.text}}
                  </option>
                </select>
              </mat-form-field>
              <mat-form-field appearance="standard" fxFlex="18" fxFlex.lt-sm="100">
                <mat-label>Organization</mat-label>
                <select id="parameterLabDetailsId{{i}}" name="parameterLabDetailsId{{i}}" [(ngModel)]="sampleViewModel.parameterResults[i].parameterLabDetailsId"
                  (change)="labChange(i, selectField.value);" #selectField matNativeControl>
                  <option *ngFor="let item of oregonWellDataService.labs" value="{{item.value}}">
                    {{item.text}}
                  </option>
                </select>
              </mat-form-field>
              <div appearance="standard" fxFlex="3" fxFlex.lt-sm="100" fxLayoutAlign="center start">
                <a href="javascript:void(0)" (click)="removeParameterResult(i)" title="Remove" mat-button color="warn">
                  <mat-icon>cancel</mat-icon>
                </a>
              </div>
            </div>
            <br />
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8px" fxLayoutAlign="start end" fxLayoutAlign.lt-sm="start">
              <button type="button" (click)="addParameterResult()" title="Add Test" mat-raised-button color="primary">
                Add Test <mat-icon>add</mat-icon>
              </button>
            </div>
            <br />
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="8px" fxLayoutAlign="start end" fxLayoutAlign.lt-sm="start">
              <mat-form-field appearance="standard" fxFlex="100">
                <mat-label>Results Comments</mat-label>
                <textarea rows="4" cols="100" [(ngModel)]="sampleViewModel.wellComment" id="wellComment" name="wellComment" matInput></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </mat-tab>
      <mat-tab label="Property and Well Information">
        <mat-card *ngIf="wellViewModel != undefined">
          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
              <small>Property and Well Information is read-only. To Edit, <a href="javascript:void(0)" mat-dialog-close="Cancel" title="Close">Close</a> this window and click on a Well Tab</small>
              <br /><br />
              <mat-card>
                <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Address</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">
                    {{wellViewModel.address1}}
                    <span *ngIf="wellViewModel.address2 !=''"><br />{{wellViewModel.address2}}</span>
                    <br />
                    {{wellViewModel.city}}, {{wellViewModel.state}}, {{wellViewModel.zip}}
                  </div>
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>County</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.county}}</div>
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Lat/Long</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.latitude}}, {{wellViewModel.longitude}}</div>
                </div>
                <br />
                <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Township</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.township}}</div>
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Range</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.range}}</div>
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Section</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.section}}</div>
                </div>
                <br />
                <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Tax Lot</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.taxLot}}</div>
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Well Log</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.wellLog}}</div>
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Well Tag</strong></div>
                  <div fxFlex="22.66" fxFlex.lt-sm="100">{{wellViewModel.tag}}</div>
                </div>
                <br />
                <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
                  <div fxFlex="10.66" fxFlex.lt-sm="100"><strong>Comments</strong></div>
                  <div fxFlex="89.34" fxFlex.lt-sm="100">{{wellViewModel.comment}}</div>
                </div>
              </mat-card>
            </div>
          </div>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </form>
</mat-dialog-content>